/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {  useState, useEffect, createContext, useContext } from 'react'
import { GET_SHOPPINGCART } from '../queries';
import { useQuery } from '@apollo/client';
import { useThemeData } from './ThemeDataContext'
import { useAuthData } from './AuthProvider'
import Loading from "../screens/loading";

export const CartContext = createContext(null)

export function useCartData() {
  return useContext(CartContext);
}

export function CartProvider ({ children }) {
  const [cartData, setCartData] = useState(undefined)
  const photographerType = useThemeData().photographerType;
  const site_id = useThemeData().themeData.site.site_id;
  const {auth, logins} = useAuthData();
  const [session_id, setSessionID] = useState(localStorage.getItem('session_id'))

  const [skipCartQuery, setSkipCartQuery] = useState(true)
  const [showCartClass, setShowCartClass] = useState('Cart-closed');

  useEffect(() => {
    if (session_id === null)
    setSessionID(localStorage.getItem('session_id'))
  }, [session_id])

    const shippingMethod = localStorage.hasOwnProperty("shippingMethod")
        ? localStorage.getItem("shippingMethod")
        : '';

  const { networkStatus: networkStatusCart, refetch: refetchCart,
    loading: loadingCart, error: errorCart, data: dataCart } =
    useQuery(GET_SHOPPINGCART, {
      variables: {
        session_id: session_id,
        site_id: site_id,
        login_name: [logins],
          shipping_method: shippingMethod
      },
      // fetchPolicy: "network-only",
      // fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
      notifyOnNetworkStatusChange: true,

      skip: skipCartQuery,
  });

  useEffect(() => {
      console.log(photographerType);
    if (photographerType === 'printservice' || photographerType === 'professionalphotographer') {
        if (session_id !== null && site_id !== "") {
            setSkipCartQuery(false)
        } else {
            setSkipCartQuery(true)  // skip the query
        }
    } else if (photographerType === 'schoolfotos' || photographerType === 'equestrianphotoservice') {
        if (!auth || site_id === "" || !logins.login_name) {
            setSkipCartQuery(true) // skip the query
        } else {
            setSkipCartQuery(false)
        }
    } else {
        setSkipCartQuery(true)  // skip the query
    }
}, [photographerType, site_id, session_id, logins, auth])

  const ShowCart = (closed) => {
    if (closed === false) { // clicked somewhere on the website
        if (showCartClass === 'Cart-opened') {
            setShowCartClass('Cart-closed');
        }
    } else {
        if (showCartClass === 'Cart-closed') {
            setShowCartClass('Cart-opened');
        } else {
            setShowCartClass('Cart-closed');
        }
    }
  }

  useEffect(() => {
    if (!loadingCart && !errorCart && dataCart !== undefined) {
        setCartData(dataCart);
    }
  // }, [])
  }, [loadingCart, errorCart, dataCart])

  const cartDisplay = { ShowCart, showCartClass, setShowCartClass };
  const cart = {cartData, networkStatusCart, refetchCart, loadingCart, errorCart, cartDisplay};

  if (loadingCart) return <Loading/>

    if (auth && (!cartData || site_id === "")) return null;

  return (
    <CartContext.Provider value={{cart}}>
      {children}
    </CartContext.Provider>
  )
}
